<template>
    <div class="transferContainer">
        <div style="margin-bottom: 20px;">
            <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
        </div>
        <el-card class="box-card" shadow="hover">
            <div class="tansferBox">
                <el-form :model="transactionHideForm" label-position="top" label-width="80px">
                    <!-- 主机构 -->
                    <el-form-item label="主机构：">
                        <el-select
                                size="medium"
                                v-model="transactionHideForm.agent_id"
                                style="width:500px"
                                multiple
                                placeholder="选择主机构">
                            <el-option
                                    v-for="item in infoTable"
                                    :key="item.username"
                                    :label="item.agent_name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="非数据优化代理商：">
                        <el-select
                                size="medium"
                                v-model="transactionHideForm.not_user_id"
                                style="width:500px"
                                placeholder="请输入代理商账号"
                                multiple
                                filterable :filter-method="notUserDataFilter">
                            <el-option
                                    v-for="item in UserList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="终端类型：">
                        <el-select
                                size="medium"
                                v-model="transactionHideForm.brand_id"
                                filterable
                                clearable
                                style="width:500px"
                                multiple
                                placeholder="请选择终端类型">
                            <el-option
                                    v-for="item in brandList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="交易类型：">
                        <el-select
                                size="medium"
                                v-model="transactionHideForm.pay_type"
                                filterable
                                clearable
                                style="width:500px"
                                multiple
                                placeholder="请选择交易类型">
                            <el-option
                                    v-for="item in payList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="非数据优化终端:">
                        <el-select
                                size="medium"
                                v-model="transactionHideForm.not_terminal_sn"
                                style="width:500px"
                                multiple
                                placeholder="请选择终端"
                                filterable :filter-method="dataFilter">
                            <el-option
                                    v-for="item in terminalList"
                                    :key="item.id"
                                    :label="item.sn"
                                    :value="item.sn"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="交易笔数">
                        <div>
                            <el-form-item style="float: left;margin-top: 20px;margin-right: 10px">
                                <span class="line">交易满</span>
                            </el-form-item>
                            <el-form-item style="float: left">
                                <el-input
                                        size="medium"
                                        style="width:100px"
                                        v-model="transactionHideForm.delay_sum"
                                ></el-input>
                            </el-form-item>
                            <el-form-item style="float: left;margin-top: 20px;margin-left: 10px">
                                <span class="line">笔</span>
                            </el-form-item>
                        </div>
                    </el-form-item>
                    <el-form-item label="激活天数">
                        <div>
                            <el-form-item style="float: left;margin-top: 20px;margin-right: 10px">
                                <span class="line">激活满</span>
                            </el-form-item>
                            <el-form-item style="float: left">
                                <el-input
                                        size="medium"
                                        style="width:100px"
                                        v-model="transactionHideForm.delay_days"
                                ></el-input>
                            </el-form-item>
                            <el-form-item style="float: left;margin-top: 20px;margin-left: 10px">
                                <span class="line">天</span>
                            </el-form-item>
                        </div>
                    </el-form-item>
                    <el-form-item label="数据优化时间区间">
                        <template>
                            <el-time-picker
                                    is-range
                                    v-model="transactionHideForm.time"
                                    value-format="HH:mm:ss"
                                    range-separator="至"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间"
                                    placeholder="选择时间范围">
                            </el-time-picker>
                        </template>
                    </el-form-item>
                    <el-form-item label="数据优化金额区间">
                        <div>
                            <el-form-item style="float: left">
                                <el-input
                                        size="medium"
                                        style="width:100px"
                                        v-model="transactionHideForm.start_money"
                                ></el-input>
                            </el-form-item>
                            <el-form-item style="float: left;margin-top: 20px;margin-left: 10px">
                                <span class="line"> 元  至 </span>
                            </el-form-item>
                            <el-form-item style="float: left;margin-left: 10px">
                                <el-input
                                        size="medium"
                                        style="width:100px"
                                        v-model="transactionHideForm.end_money"
                                ></el-input>
                            </el-form-item>
                            <el-form-item style="float: left;margin-top: 20px;margin-left: 10px">
                                <span class="line"> 元 </span>
                            </el-form-item>
                        </div>
                    </el-form-item>
                    <el-form-item label="优化方案">
                        <div>
                            <el-form-item style="float: left;margin-top: 20px;margin-right: 10px">
                                <span class="line"> 每 </span>
                            </el-form-item>
                            <el-form-item style="float: left">
                                <el-input
                                        size="medium"
                                        style="width:100px"
                                        v-model="transactionHideForm.transaction_sum"
                                ></el-input>
                            </el-form-item>
                            <el-form-item style="float: left;margin-top: 20px;margin-left: 10px">
                                <span class="line"> 笔 优化 </span>
                            </el-form-item>
                            <el-form-item style="float: left;margin-left: 10px">
                                <el-input
                                        size="medium"
                                        style="width:100px"
                                        v-model="transactionHideForm.transaction_handle"
                                        readonly
                                ></el-input>
                            </el-form-item>
                            <el-form-item style="float: left;margin-top: 20px;margin-left: 10px">
                                <span class="line"> 笔 交易 </span>
                            </el-form-item>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>

export default {
    name: "MAM_transferTerminal",
    data() {
        return {
            info: {
                isShow: false,
                detail: []
            },
            transferMethod: 2,
            terminalList: [], //穿梭框终端数据源
            UserList: [], //穿梭框用户数据源
            infoTable: [], //划拨用户
            brandList: [], //终端类型下拉框
            payList: [], //交易类型下拉框
            transactionHideForm: {
                agent_id:'',  //主机构id
                not_user_id:[], //非优化user_id
                brand_id:[], //终端类型
                pay_type:[], //交易类型
                not_terminal_sn:[], //非优化终端
                delay_sum:'', //交易笔数
                delay_days:'', //激活天数
                time:'',  //非数据优化时间
                start_money:'', //非数据优化最低金额
                end_money:'', //非数据优化最高金额
                transaction_sum:'', //每xx笔优化xx笔交易
                transaction_handle:'1', //每xx笔优化xx笔交易
            },
            loading: false,
        }
    },
    mounted() {
        this.$api.post('agent/get_list', {limit:100,page:1}, res => {
            if (res.code == 0) {
                this.infoTable = res.data.list;
                //渲染结束后取消加载
                this.loading = false;
            } else {
                this.$message.error(res.msg);
                //渲染结束后取消加载
                this.loading = false;
            }
        });
        this.$api.post('brand/brand_list', {}, res => { //获取终端类型
            if (res.code == 0) {
                this.brandList = res.data.list;
            } else {
                this.$message.error(res.msg);
            }
        });
        this.$api.post('type/pay_type', {}, res => { //获取交易类型
            if (res.code == 0) {
                this.payList = res.data;
            } else {
                this.$message.error(res.msg);
            }
        });
    },
    methods: {
        onSubmit() {
            this.$api.post('transaction/transaction_hide', this.transactionHideForm, res => {
                if (res.code == 0) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        dataFilter(val){
            this.$api.post('terminal/one_terminal', {sn:val,agent_id:this.transactionHideForm.agent_id}, res => {
                if (res.code == 0) {
                    this.terminalList = res.data
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        notUserDataFilter(val){
            this.$api.post('user/all_lower_user', {phone:val,agent_id:this.transactionHideForm.agent_id}, res => {
                if (res.code == 0) {
                    this.UserList = res.data
                } else {
                    this.$message.error(res.msg);
                }
            });
        }
    },
}
</script>

<style scoped lang="scss">
.transferContainer {
  .tansferBox {
    min-width: 920px;
  }
  font-size: 12px !important;
  .title {
    margin: 20px 0 10px 0;
    color: #606266;
    :nth-child(1) {
      font-weight: 700;
    }
  }
  .el-input__inner,
  ::v-deep .el-radio__label {
    font-size: 12px;
  }
  .el-form-item {
    margin-bottom: 5px;
    ::v-deep .el-form-item__label {
      padding: 0;
      font-weight: 700;
      font-size: 12px;
    }
    ::v-deep .el-form-item__content {
      line-height: 0;
    }
  }
  ::v-deep .el-checkbox__label {
    font-size: 12px;
  }
  ::v-deep .el-transfer {
    font-size: 12px;
    .el-transfer-panel__header {
      .el-checkbox__label {
        font-size: 13px;
        font-weight: 700;
      }
    }
    .el-transfer-panel {
      width: 40%;
    }
  }
  .batchTip {
    line-height: 15px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
